<fieldset ngModelGroup="education{{index}}" class="educationForm">
  <div class="row" *ngIf="index !== 0">
    <div class="col-8"></div>
    <div class="col-4 text-right">
      <a href="javascript:void(0);" class="btn btn-link mt-2" (click)="remove.emit()">Remove Entry</a>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showSchoolName">
    <div class="col-12">
      <div class="form-group">
        <label [class.required]="configuration.requireSchoolName" for="school{{index}}">School</label>
        <input #school="ngModel" id="school{{index}}" name="School{{index}}" mdbInput mdbValidate type="text"
               [required]="configuration.requireSchoolName"
               class="form-control" [(ngModel)]="education.institutionName" />
        <mdb-error *ngIf="school.invalid && (school.dirty || school.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="degree{{index}}" [class.required]="true">Degree</label>
        <input #degree="ngModel" id="degree{{index}}" name="Degree{{index}}" mdbInput mdbValidate type="text" required
               class="form-control" [(ngModel)]="education.degree" />
        <mdb-error *ngIf="degree.invalid && (degree.dirty || degree.touched)">Required field.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6 pt-md-3 mb-3 mb-md-0" *ngIf="configuration.showDegreeStatus">
      <div class="form-check">        
        <mdb-checkbox id="attending{{index}}" name="attending{{index}}" mdbInput
                      class="form-check-input" [(ngModel)]="education.currentlyAttending" (ngModelChange)="onCurrentlyAttendingChange()">
          Currently Attending
        </mdb-checkbox>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showMajor">
    <div class="col-sm-12">
      <div class="form-group">
        <label for="major{{index}}" [class.required]="configuration.requireMajor">Major or field of study <span *ngIf="!configuration.requireMajor">(Optional)</span></label>
        <input #major="ngModel" id="major{{index}}" name="major" mdbInput mdbValidate type="text"
               [required]="configuration.requireMajor"
               class="form-control" [(ngModel)]="education.major" />
        <mdb-error *ngIf="major.invalid && (major.dirty || major.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showFromToDates">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireFromToDates" for="fromDate{{index}}">From Date (mm/yyyy) <span *ngIf="!configuration.requireFromToDates">(Optional)</span></label>
        <input #fromDate="ngModel" id="fromDate{{index}}" name="fromDate" mdbInput mdbValidate type="text"
               [required]="configuration.requireFromToDates" pattern="^(0[1-9]|1[012])/\d{4}$"
               class="form-control" [ngModel]="education.startDate | date:'MM/yyyy':'UTC'" (ngModelChange)="onStartDateChanged($event)" />
        <mdb-error *ngIf="fromDate.invalid && (fromDate.dirty || fromDate.touched)">Valid date required.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireFromToDates" for="toDate{{index}}">To Date (mm/yyyy) <span *ngIf="!configuration.requireFromToDates">(Optional)</span></label>
        <input #toDate="ngModel" #toDateInput id="toDate{{index}}" name="toDate" mdbInput mdbValidate type="text"
               [disabled]="disableToDate" [required]="configuration.requireFromToDates" pattern="^(0[1-9]|1[012])/\d{4}$"
               class="form-control" [ngModel]="education.endDate | date:'MM/yyyy':'UTC'" (ngModelChange)="onEndDateChanged($event)" />
        <mdb-error *ngIf="toDate.invalid && (toDate.dirty || toDate.touched)">Valid date required.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showComments">
    <div class="col-12">
      <div class="form-group">
        <label [class.required]="configuration.requireComments">Comments <span *ngIf="!configuration.requireComments">(Optional)</span></label>
        <textarea #comments="ngModel" id="comments{{index}}" name="comments" mdbInput mdbValidate
                  [required]="configuration.requireComments"
                  class="form-control md-textarea" [(ngModel)]="education.comments"></textarea>
        <mdb-error *ngIf="comments.invalid && (comments.dirty || comments.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
</fieldset>
